import {useEffect} from 'react';

export const usePeriodicMutation = (
  mutation: () => void,
  intervalMs: number,
) => {
  useEffect(() => {
    const run = () => {
      mutation();
    };
    run();
    const id = setInterval(run, intervalMs);
    return () => clearInterval(id);
  }, []);
};
